import { render, staticRenderFns } from "./CapitalOverview.vue?vue&type=template&id=0c1b5d5c&scoped=true&"
import script from "./CapitalOverview.vue?vue&type=script&lang=ts&"
export * from "./CapitalOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalOverview.vue?vue&type=style&index=0&id=0c1b5d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b5d5c",
  null
  
)

export default component.exports